import { render, staticRenderFns } from "./MyMessageLeft.vue?vue&type=template&id=ac141d7c&scoped=true"
import script from "./MyMessageLeft.vue?vue&type=script&lang=js"
export * from "./MyMessageLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac141d7c",
  null
  
)

export default component.exports